<template>
    <div class="d-flex flex-row nowrap align-items-center" style="gap: 5px;">
        <input class="ts-form-check-input" :disabled="props.disabled" type="checkbox" :checked="props.active" @change="handleClick"/>
        <label>
            <slot>
                {{ props.option?.label || "" }}
            </slot>
        </label>
    </div>
</template>

<script lang="ts" setup>
import { defineProps, defineEmits } from 'vue'

type Value = string | number | boolean
type Option = {
    value: Value
    label: string
}

interface Props {
    disabled?: boolean
    error?: boolean
    option?: Option
    active: boolean
}
interface Emits {
    (e: 'checkboxClick', option?: Option): void
}

// props
const props = defineProps<Props>()

// emit
const emit = defineEmits<Emits>()

// handlers
const handleClick = (e: any) => {
    emit('checkboxClick', e.target.value)
}
</script>

<style  scoped>

</style>
